import { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { track } from "../../utils/track";

interface FreeTierDetail {
  usage?: { activeDays: number; monthlyLimit: number | null; plan: string | null };
  message?: string;
}

export const UpgradeNotice = () => {
  const [show, setShow] = useState(false);
  const [detail, setDetail] = useState<FreeTierDetail | null>(null);

  useEffect(() => {
    const onLimit = (e: Event) => {
      const ce = e as CustomEvent<FreeTierDetail>;
      setDetail(ce.detail || null);
      setShow(true);
    };
    window.addEventListener("free-tier-limit", onLimit);
    return () => window.removeEventListener("free-tier-limit", onLimit);
  }, []);

  const usage = detail?.usage;

  return (
    <Modal show={show} onHide={() => setShow(false)} centered>
      <Modal.Header closeButton>
        <Modal.Title>Uppgradera för att fortsätta</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Free-planen är begränsad till {usage?.monthlyLimit ?? 5} aktiva dagar per
          månad. Du har använt {usage?.activeDays ?? "alla"} dagar den här månaden.
        </p>
        <p className="text-muted mb-0">
          Uppgradera för obegränsad åtkomst till prognoser och nyhetsanalys.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="link" onClick={() => setShow(false)}>Stäng</Button>
        <Button
          variant="primary"
          onClick={() => {
            track("cta_click", "upgrade");
            window.location.href = "/account";
          }}
        >
          Uppgradera
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
